import EN from './translations/en_US/translations.json'
import FR from './translations/fr_FR/translations.json'
import IT from './translations/it_IT/translations.json'
import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'

i18n.use(initReactI18next).init({
  interpolation: { escapeValue: false }, // React already does escaping
  lng: 'en', // language to use
  defaultNS: 'translations',
  react: {
    useSuspense: false,
  },
  resources: {
    en: {
      translations: EN, // 'translations' is our custom namespace
    },
    fr: {
      translations: FR,
    },
    it: {
      translations: IT,
    },
  },
})

export default i18n
